import { ComunidadNewsFeed } from "@/hooks/api/comunidad";
import { NewsArchiveContent } from "./comunidad/NewsArchiveContent";

interface NewsArchiveTabProps {
  feed: ComunidadNewsFeed;
}

export const NewsArchiveTab = ({ feed }: NewsArchiveTabProps) => {
  return <NewsArchiveContent feed={feed} />;
};
